export default __webpack_public_path__ + "static/media/medium.6a76c92f.svg";